<template>

    <div>
                      <div class="tabs-component">
                        <ul class="nav nav-tabs nav-justified">
                          <li class="nav-item">
                            <a class="nav-link active" data-bs-target="#video_screens" href="#video_screens" data-bs-toggle="tab">Videos</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-bs-target="#documents_screen" href="#documents_screen" data-bs-toggle="tab">Documents</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-bs-target="#banners" href="#banners" data-bs-toggle="tab">Banners</a>
                          </li>
       
                          <li class="nav-item" >
                            <a class="nav-link" data-bs-target="#logos" href="#logos" data-bs-toggle="tab">Logos</a>
                          </li>
                           <li class="nav-item">
                            <a class="nav-link" :data-bs-target="`#three-dmodels`" :href="`#three-dmodels`" data-bs-toggle="tab">3D Models</a>
                        </li>
                        </ul>
                      </div>
                      <form @submit.prevent="submitForm" novalidate>
                        <OverlayLoading :isLoading="loading" />
                          
                    
                            <div class="tab-content">
                                <div id="video_screens" class="tab-pane active">
                                    <div class="containter eventhall_flags">
                                        <div class="form-group row">
                                            <div class="col-lg-12">

                                                <div id ="multiple_images">
                                                    <input
                                                        placeholder="Upload Multiple Videos"
                                                        type="file"
                                                        class="form-control"
                                                        @change="updateVideos"
                                                        multiple="multiple"
                                                        accept="video/mp4"
                                                        
                                                    />
                                                    <p> Should be in MP4 format(Max Limit 1)</p>
                                                </div>
                                    
                                            </div>
                                                <div class="image-list">
                                                        <div class="image-item" v-for="file in item.videos" v-bind:key="file">
                                                        <video :src="IMAGE_URL + file.key" alt="Image 1" controls class="video-player"/> 
                                                            <div class="image-details">
                                                                <span class="image-name">{{getFileName(file.key)}}</span>
                                                                <button type="button" class="remove-btn" @click="removeVideoAsset($event, file.key)">Remove</button>
                                                            </div>
                                                        </div>
                                                </div>
                                        </div>


                                    </div>
                                    <div class="event_detail_wrapper">
                                        <div class="row">
                                            <div class="col-md-2">
                                            <label for="address">Screen Description 1 </label>
                                            </div>
                                            <div class="col-md-4">
                                            <div class="input-group">
                                                <input type="text" class="form-control" name="screen description" :value="item.screen_description1" @input="updateScreenDescription1" />
                                            </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="event_detail_wrapper">
                                        <div class="row">
                                            <div class="col-md-2">
                                            <label for="address">Screen Description 2 </label>
                                            </div>
                                            <div class="col-md-4">
                                            <div class="input-group ">
                                                <input type="text" class="form-control" name="screen description" :value="item.screen_description2" @input="updateScreenDescription2" />
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    

                                </div> <!--End Of tab video screen-->

                                <div id="documents_screen" class="tab-pane">
                                    <div class="containter eventhall_flags">
                                        <div class="form-group row">
                                            <div class="col-lg-12">

                                                <div id ="multiple_images">
                                                    <input
                                                        placeholder="Upload Multiple Documents"
                                                        type="file"
                                                        class="form-control"
                                                        @change="updateDocuments"
                                                        multiple="multiple"
                                                        accept="application/pdf"
                                                        
                                                    />
                                                    <p> Should be in PDF format and (Max Limit 2)</p>
                                                </div>
                                    
                                            </div>
                                                <div class="image-list">
                                                        <div class="image-item" v-for="file in item.documents" v-bind:key="file">
                                                            <div class="image-details">
                                                                <span class="image-name">{{getFileName(file.key)}}</span>
                                                                <button type="button" class="remove-btn" @click="removeDocumentAsset($event, file.key)">Remove</button>
                                                            </div>
                                                        </div>
                                                </div>
                                        </div>


                                    </div>


                                </div><!--Endo of Document Screen-->

                                <div id="banners" class="tab-pane">

                                    <div class="containter eventhall_flags">
                                        <div class="form-group row">
                                            <div class="col-lg-12">

                                                <div id ="multiple_images">
                                                    <input
                                                        placeholder="Upload Multiple Banners"
                                                        type="file"
                                                        class="form-control"
                                                        @change="updateBanners"
                                                        multiple="multiple"
                                                        accept="image/jpeg"
                                                        
                                                    >
                                                    <span>Upload Multiple Medium Banners (Max Limit 2 & Suggested Resolution:1200X750) </span>
                                                </div>
                                    
                                            </div>
                                            <div class="image-list">
                                                        <div class="image-item" v-for="file in item.banners" v-bind:key="file">
                                                        <img :src="IMAGE_URL + file.key" alt="Image 1" >
                                                        <div class="image-details">
                                                            <span class="image-name">{{getFileName(file.key)}}</span>
                                                            <button type="button" class="remove-btn" @click="removeBannerAsset($event, file.key)">Remove</button>
                                                        </div>
                                                        </div>
                                                </div>
                                        </div>


                                    </div>



                                </div><!--End Of Booth Logo-->
                                <div id="logos" class="tab-pane"  >
                                    <div class="containter eventhall_flags">
                                        <div class="form-group row">
                                            <div class="col-lg-12">

                                                <div id ="multiple_images">
                                                    <input
                                                        placeholder="Upload Multiple Logos"
                                                        type="file"
                                                        class="form-control"
                                                        @change="updateLogos"
                                                        multiple="multiple"
                                                        accept="image/jpeg"
                                                        
                                                    >
                                                    <span>Upload Multiple Logo (Max Limit 2 & Suggested Resolution:450x150) </span>
                                                </div>
                                    
                                            </div>
                                            <div class="image-list">
                                                        <div class="image-item" v-for="file in item.logos" v-bind:key="file">
                                                        <img :src="IMAGE_URL + file.key" alt="Image 1" >
                                                        <div class="image-details">
                                                            <span class="image-name">{{getFileName(file.key)}}</span>
                                                            <button type="button" class="remove-btn" @click="removeLogoAsset($event, file.key)">Remove</button>
                                                        </div>
                                                        </div>
                                                </div>
                                        </div>


                                    </div>
                                </div> <!--End of Logos-->

                                 <div :id="`three-dmodels`" class="tab-pane">
                    <div class="snippet general-event-config-snippet">
                      <div class="form-group row">
                        <div class="col-lg-8">
                                        
                            <DropFiles
                                    :file="validate_file(item.model1)"
                                    :module_id="item._id?item._id:this.moduleId"
                                    @onUploaded="updateModel1"
                                    @onRemoved="removeModel1"
                                    :accept="'.fbx'"   
                                    module_type="events"
                                    asset_type="model_image" 
                                    @onError="errCb"
                                >
                            <template #header>
                                <label>3D Model 1 (Should be in FBX format and Size not more than 10 MB)</label>
                            </template>
                            <template #tooltip>
                                <VTooltip style="display:inline-block">
                                <i class="fa fa-info-circle" style="font-size:16px"></i>
                                <template #popper>
                                    <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                                </template>
                                </VTooltip>
                            </template>
                            </DropFiles>

                        </div>
                      </div>
                    </div>
                 </div>

                            </div><!--End Of tab!-->
                        <div class="form-group row">
                            <div class="offset-md-10 col-md-2">
                                <div class="setting_wrapper">
                                    <button type="submit" class="btn btn-primary">Save</button>
                                    <button type="button" class="mb-1 mt-1 me-1 btn btn-danger" @click="cancelClick">Cancel</button>
                                   
                        
                                </div>
                            </div>
                        </div>
                        <FlashMessage group="booth_content_create" />
                     </form> 
    
                </div>  
    </template>
      
      <script>
      import { gettingErrorMessage } from "@/services/GetValidationMessage";
      import { mapGetters, mapActions } from 'vuex'
      import { useVuelidate } from '@vuelidate/core'
      import { required, email } from '@vuelidate/validators'
      import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
      import _ from "lodash";
      import { upload, remove } from "@/services/FileUploader";
      import ObjectID from 'bson-objectid';
      import constants from "@/config/constants";
      const maxDocumentFileSize = 2000000; //1024000;
      
      export default {
        name: 'BoothDataCreateForm',
        components: {
            
        },
        setup() {
          return {
            v$: useVuelidate()
          }
        },
        data() {
            return {
              moduleId: ObjectID().toHexString(),
              IMAGE_URL: constants.IMAGE_URL
            }
          },
          watch: {
             
        },
        props: {
        booth_id: String
        },
        validations() {
          return {
            item: {
              
            }
          };
        },
        created(){
            this.fetchEventData(this.$route.params.event_id);
            this.fetchConfiguration();
        },
       
        beforeUnmount() {
          this.resetState();
          delete this.$flashMessage.groups.booth_content_create;
        },
        computed: {
        ...mapGetters('BoothContentsSingle', ['item', 'loading', 'is_new']),
        ...mapGetters("EventsSingle", {"eventItem": "item"}),
        ...mapGetters('ConfigurationsSingle', {'projectConfiguration':'item'}),

        },
        mounted(){
            this.fetchData(this.booth_id)
     
        },
        methods: {
            ...mapActions("EventsSingle",{"fetchEventData":"fetchData"}),
            ...mapActions('ConfigurationsSingle', {'fetchConfiguration': 'fetchData'}),      
            ...mapActions('BoothsIndex', {setEditId: "setEditId",fetchAllData :'fetchData'}),
      
            ...mapActions('BoothContentsSingle', [
            'fetchData',
            'setItem',
            'storeData',
            'updateData',
            'resetState',
            'setIsNew',
            'setShowVideos',
            'setDisableDownloadVideo1',
            'setDisableDownloadScreenDocument1',
            'setScreen_document1',
            'setDisableDownloadVideo2',
            'setDisableDownloadScreenDocument2',
            'setScreen_video1',
            'setScreen_video2',
            'setScreen_document1',
            'setScreen_document2',
            'setShowText',
            'setDescription',
            'setBoothLogo',
            'setPresentation1',
            'setPresentation2',
            'setDisableDownloadPresentation1',
            'setDisableDownloadPresentation2',
            'setBanner',
            'removeBanner',
            'setLogo',
            'removeLogo',
            'setVideo',
            'removeVideo',
            'setDocument',
            'removeDocument',
            'setScreenDescription1',
            'setScreenDescription2',
            'setModel1'
            ]),
             validate_file(fileInfo) {
                // console.log(fileInfo);
                if (_.has(fileInfo, 'key'))
                    return fileInfo;
                return null;
            },
            getFileName(str){
                let stringNew =  str.split("/").pop();
                return stringNew.slice(-25);
            },
            updateShowVideos(e){
                this.setShowVideos(e.target.checked);
            },
            updateDisableDownloadVideo1(e) {
              this.setDisableDownloadVideo1(e.target.checked);
            },
            updateDisableDownloadScreenDocument1(e){
                this.setDisableDownloadScreenDocument1(e.target.checked);
            },
            updateDisableDownloadVideo2(e) {
              this.setDisableDownloadVideo2(e.target.checked);
            },
            updateDisableDownloadScreenDocument2(e){
                this.setDisableDownloadScreenDocument2(e.target.checked);
            },
        
            removeScreen_video1(e, id) {
              this.setScreen_video1(null);
            },
            async updateScreen_video1(info, data) {
                if (!_.has(data.data, 'Key')) {
                        return;
                }
                const extension = data.data.Key.split('.').pop();
                const key = _.get(this.item.screen_video1, 'Key', null);
                const size = _.get(info, 'file.size', 0);
                this.setScreen_video1({
                    old_key   : key,
                    key       : data.data.Key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                });      
            },
            removeScreen_document1(e, id) {
              this.setScreen_document1(null);
            },
            async updateScreen_document1(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.screen_document1, 'key', null);
                const size = _.get(info, 'file.size', 0);
                
                this.setScreen_document1({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeScreen_video2(e, id) {
                this.setScreen_video2(null);
            },
            async updateScreen_video2(info, data) {
                if (!_.has(data.data, 'Key')) {
                        return;
                }
                const extension = data.data.Key.split('.').pop();
                const key = _.get(this.item.screen_video2, 'Key', null);
                const size = _.get(info, 'file.size', 0);
                this.setScreen_video2({
                    old_key   : key,
                    key       : data.data.Key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                });      
            },
            removeScreen_document2(e, id) {
              this.setScreen_document2(null);
            },
            async updateScreen_document2(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.screen_document2, 'key', null);
                const size = _.get(info, 'file.size', 0);
                this.setScreen_document2({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            errCb(e) {
            this.$flashMessage.show({
                group : 'booth_content_create',
                type  : 'error',
                title : 'Failed',
                text  : "Invalid File format.Please use described valid format"
              });
          },
    
          errCbDocument(e) {
            this.$flashMessage.show({
                group : 'booth_content_create',
                type  : 'error',
                title : 'Failed',
                text  : "Uploaded document size not more than 100 KB."
              });
          },
    
          // Document 
    
          updateShowText(e){
            this.setShowText(e.target.checked);
         
          },
          updateDescription(e){
            this.setDescription(e.target.value);
          },
          async updateDocument1(info,data){
            if (!_.has(data.data, 'key')) {
                        return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.document1, 'key', null);
            const size = _.get(info, 'file.size', 0);
    
            console.log("Fiel size",size,"===>",maxDocumentFileSize);
            if(size.toString()>maxDocumentFileSize){
                this.errCbDocument();
                return;
            }
            this.setDocument1({
                old_key   : key,
                key       : data.data.key,
                temp_key  : info.id,
                size      : size.toString(),
                extension : extension,
                uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2026.01.01',
            }); 
            },
            removeDocument1(e, id) {
              this.setDocument1(null);
            },
    
            async updateDocument2(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document2, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument2({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument2(e, id) {
              this.setDocument2(null);
            },
    
            async updateDocument3(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document3, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument3({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument3(e, id) {
              this.setDocument3(null);
            },
    
            async updateDocument4(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document4, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument4({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument4(e, id) {
              this.setDocument4(null);
            },
            async updateDocument5(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document5, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument5({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument5(e, id) {
              this.setDocument5(null);
            },
            async updateDocument6(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document6, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument6({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument6(e, id) {
              this.setDocument6(null);
            },
            async updateDocument7(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document7, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument7({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument7(e, id) {
              this.setDocument7(null);
            },
            async updateDocument8(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document8, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument8({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument8(e, id) {
              this.setDocument8(null);
            },
            async updateDocument9(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document9, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument9({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument9(e, id) {
              this.setDocument9(null);
            },
            async updateDocument10(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document10, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument10({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument10(e, id) {
              this.setDocument10(null);
            },
            async updateDocument11(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document11, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument11({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument11(e, id) {
              this.setDocument11(null);
            },
            async updateDocument12(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document12, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument12({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument12(e, id) {
              this.setDocument12(null);
            },
            async updateDocument13(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document13, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument13({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            removeDocument13(e, id) {
              this.setDocument13(null);
            },
            async updateDocument14(info,data){
                if (!_.has(data.data, 'key')) {
                        return;
                }
                const extension = data.data.key.split('.').pop();
                const key = _.get(this.item.document14, 'key', null);
                const size = _.get(info, 'file.size', 0);
                if(size.toString()>maxDocumentFileSize){
                    this.errCbDocument();
                    return;
                }
                this.setDocument14({
                    old_key   : key,
                    key       : data.data.key,
                    temp_key  : info.id,
                    size      : size.toString(),
                    extension : extension,
                    uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                    uploadedAt: '2026.01.01',
                }); 
            },
            
            async submitForm() {
                this.updateData(this.booth_id)
                .then(() => {
                    this.$flashMessage.show({
                    group: 'booths',
                    type: 'success',
                    title: 'Success',
                    text: "Event Booth updated successfully",
                    });
                    this.resetState();
                    this.setEditId(null);
                    this.fetchAllData(this.$route.params.event_id);
                })
                .catch((error) => {
                console.log("Errro",error);
                let html =  gettingErrorMessage(error);
                this.$flashMessage.show({
                        group : 'booth_content_create',
                        type  : 'error',
                        title : 'Error',
                        text  : html,
                        html  : html
                    });
                });
            },
            async updateBanners(e){
            try {
                let image_qty   = 1; 
                let preset_name = this.item.presets.name;
                if(preset_name ===   "2V1P" || preset_name === "2P1V" ){
                    image_qty = 2
                }
                let totalDocs = this.item.banners.length + e.target.files.length;
                if (totalDocs > image_qty) {
                    alert(`You can not upload banners more than ${image_qty} in this preset ${preset_name}`);
                    return;
                }

                
                const files = e.target.files;
                for(let file of files){
                    let file_size = file.size;
                    let img_ext = file.name.split('.').pop().toLowerCase();
                    if(['jpg','jpeg'].includes(img_ext) ==false){
                        this.errCb();
                        return;
                    }
                    
                }
                const user = JSON.parse(localStorage.getItem('user'));
                for(let file of files){
                    let file_size = file.size;
                    let id = ObjectID();
                    let resp = await upload(file, id, "events", '1200X750', 'banners');
                    let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                    let extension = fileKey.split('.').pop();

                    this.setBanner({
                        key: fileKey,
                        old_key: fileKey,
                        temp_key: id,
                        size: file_size.toString(),
                        extension: extension,
                        uploadedBy: user.first_name + ' ' + user.last_name,
                        uploadedAt: '2023.01.01',
                    });
                }
                
            } catch (e) {
                this.$flashMessage.show({
                group: 'booth_content_create',
                type: 'error',
                title: 'Error',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                });
            }
        },
        removeBannerAsset(e, id) {
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
            if (typeof result.dismiss === "undefined") {
                remove(id).then(() => {
                this.removeBanner(id);
                })
            }
        });
        },
        async updateLogos(e){
            try {
                let image_qty   = 2; 
                let preset_name = this.item.presets.name;
                if(preset_name ===   "2V1P" || preset_name === "2P1V" ){
                    image_qty = 2
                }
                let totalDocs = this.item.logos.length + e.target.files.length;
                if (totalDocs > image_qty) {
                    alert(`You can not upload logos more than ${image_qty} in this preset ${preset_name}`);
                    return;
                }
                

                const files = e.target.files;
                for(let file of files){
                    let file_size = file.size;
                        let img_ext = file.name.split('.').pop().toLowerCase();
                        if(['jpg','jpeg'].includes(img_ext) ==false){
                            this.errCb();
                            return;
                        }
                    
                }
                const user = JSON.parse(localStorage.getItem('user'));
                for(let file of files){
                    let file_size = file.size;
                    let id = ObjectID();
                    let resp = await upload(file, id, "events", '450X150', 'logos');
                    let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                    let extension = fileKey.split('.').pop();

                    this.setLogo({
                        key: fileKey,
                        old_key: fileKey,
                        temp_key: id,
                        size: file_size.toString(),
                        extension: extension,
                        uploadedBy: user.first_name + ' ' + user.last_name,
                        uploadedAt: '2023.01.01',
                    });
                }
                
            } catch (e) {
                console.log("Error in set",e);
                this.$flashMessage.show({
                group: 'booth_content_create',
                type: 'error',
                title: 'Error',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                });
            }
        },
        removeLogoAsset(e, id) {
            console.log("removeid",id);
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeLogo(id);
                    })
                }
            });
        },
        async updateVideos(e){
            try {
                
                let image_qty   = 1; 
                let preset_name = this.item.presets.name;
                let totalDocs = this.item.videos.length + e.target.files.length;
                if (totalDocs > image_qty) {
                        alert(`You can not upload videos more than ${image_qty} in the preset ${preset_name}`);
                    return;
                }
                
                const files = e.target.files;
                for(let file of files){
                    let file_size = file.size;
                        let img_ext = file.name.split('.').pop().toLowerCase();
                        if(['mp4'].includes(img_ext) ==false){
                            this.errCb();
                            return;
                        }
                    
                }
                const user = JSON.parse(localStorage.getItem('user'));
                for(let file of files){
                    let file_size = file.size;
                    let id = ObjectID();
                    let resp = await upload(file, id, "events", null, 'videos');
                    let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                    let extension = fileKey.split('.').pop();

                    this.setVideo({
                        key: fileKey,
                        old_key: fileKey,
                        temp_key: id,
                        size: file_size.toString(),
                        extension: extension,
                        uploadedBy: user.first_name + ' ' + user.last_name,
                        uploadedAt: '2023.01.01',
                    });
                }
                
            } catch (e) {
                console.log("Error in set",e);
                this.$flashMessage.show({
                group: 'booth_content_create',
                type: 'error',
                title: 'Error',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                });
            }
        },
        removeVideoAsset(e, id) {
            console.log("removeid",id);
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeVideo(id);
                    })
                }
            });
        },
        async updateDocuments(e){
            try {
                let image_qty   = 2; 
                let preset_name = this.item.presets.name;
                let totalDocs = this.item.documents.length + e.target.files.length;
                if (totalDocs > image_qty) {
                    alert(`You can not upload documents more than ${image_qty} in the preset ${preset_name}`);
                    return;
                }
                
                let pdfSize = this.getFileSizeConfigurationDocument();






                const files = e.target.files;
                for(let file of files){
                    let file_size = file.size;
                    let img_ext = file.name.split('.').pop().toLowerCase();
                    if(['pdf'].includes(img_ext) ==false){
                        this.errCb();
                        return;
                    }
                    if(file_size>pdfSize){
                        this.showCbError();
                        return;
                    }
                    
                }
                const user = JSON.parse(localStorage.getItem('user'));
                for(let file of files){
                    let file_size = file.size;
                    let id = ObjectID();
                    let resp = await upload(file, id, "events", null, 'documents');
                    let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                    let extension = fileKey.split('.').pop();

                    this.setDocument({
                        key: fileKey,
                        old_key: fileKey,
                        temp_key: id,
                        size: file_size.toString(),
                        extension: extension,
                        uploadedBy: user.first_name + ' ' + user.last_name,
                        uploadedAt: '2023.01.01',
                    });
                }
                
            } catch (e) {
                console.log("Error in set",e);
                this.$flashMessage.show({
                group: 'booth_content_create',
                type: 'error',
                title: 'Error',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                });
            }
        },
        removeDocumentAsset(e, id) {
            console.log("removeid",id);
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeDocument(id);
                    })
                }
            });
        },  
        updateScreenDescription1(e){
            this.setScreenDescription1(e.target.value);
        },
        updateScreenDescription2(e){
            this.setScreenDescription2(e.target.value);
        },
        cancelClick(){
            this.setEditId(null);
        },
        getFileSizeConfigurationDocument(){
            if(this.eventItem.max_document_size && this.eventItem.max_document_size>0){
                return this.eventItem.max_document_size
            }
            return this.projectConfiguration.max_document_size
        },
        getFileSizeConfigurationVideo(){
            if(this.eventItem.max_video_size && this.eventItem.max_video_size>0){
                return this.eventItem.max_video_size
            }
            return this.projectConfiguration.max_video_size
        },
        showCbError(e){
            this.$flashMessage.show({
                group : 'booth_content_create',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Uploaded document should be less than 30 MB.</li></ul>"

            })
        },
        showVideoError(e){
            this.$flashMessage.show({
                group : 'booth_content_create',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Uploaded video should be less than 500 MB.</li></ul>"

            })
        },
        updateModel1(info, data) {
            const key = _.get(this.item.model1, 'key', null);
            const size = _.get(info, 'file.size', 0); // size in bytes
            console.log("2:--Checking FBX size ********size", size);

            const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
            if (size > maxSize) {
                this.showVideoError();
                return; // stop further processing
            }

            let fileKey = data.data.key ? data.data.key : data.data.Key;
            const extension = fileKey.split('.').pop();
            // FBX file type validation
            // Get the original file type from the uploaded file
            const originalFileType = info.file.type.toLowerCase();
            const fileName = info.file.name.toLowerCase();
            
            // Check if extension is FBX and MIME type is appropriate
            let img_ext = fileName.split('.').pop().toLowerCase();
            console.log("Image Extension====>",img_ext)
            if(['fbx'].includes(img_ext) ==false){
                 this.errCb();
                return;
                                
            }
            this.setModel1({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        removeModel1(e) {
          this.setModel1(null);
        },
        },
        
            
          
        
      }
      </script>
      
      <style lang="scss" scoped>
      .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.image-item {
    width: 300px;
    border: 1px solid #ccc;
    padding: 10px;
    box-sizing: border-box;
}

.video-player {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
}

.image-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

.remove-btn {
    background-color: #ff4d4d;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
}

.remove-btn:hover {
    background-color: #cc0000;
}
      .event_detail_wrapper {
        border-bottom: 1px solid #ccc;
        padding: 10px 0px;
      
        .event_ls_label {
          font-weight: bold;
        }
      }
      
      .setting_wrapper {
        float: right;
      
        a {
          color: #201e1eba;
          padding: 9px;
          margin-left: 5px;
          background: #c0cdd345;
          border-radius: 4px;
          border: 1px solid #80808054;
        }
      }
      
      .form-btn {
        color: #201e1eba;
        padding: 9px;
        margin-left: 5px;
        background: #c0cdd345;
        border-radius: 4px;
        border: 1px solid #80808054;
      
        &.save-btn {
          background: rgba(210, 206, 201, 0.27);
        }
      }
      
      
     
      .radio{
          padding:5px;
      }
      label > input{ /* HIDE RADIO */
        display:none;
      }
      label > input + img{ /* IMAGE STYLES */
        cursor:pointer;
        border: 1px dashed #444;
        width: 150px;
        height: 150px;
        transition: 500ms all;
      }
      label > input:checked + img{ /* (CHECKED) IMAGE STYLES */
        /* border:2px solid #f00; */
        opacity:1;
        border: 1px solid #fff;
        box-shadow: 0 0 3px 3px #090;
        
      }
      .form-inline{
        display:flex;
      }
    
      .pl-10{
        padding-left:10px!important;
      }
    .image-item {
        display: flex;
        align-items: center;
        gap: 15px;
        background-color: #fff;
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        width: 250px!important;
}

.image-item img {
  width: 100px !important;
  height: 60px !important;
  object-fit: cover;
  border-radius: 5px;
}
      
      </style>
      